'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _components = require('../../components');

var _SolutionDefaultSustainability = require('./SolutionDefaultSustainability.css');

var _SolutionDefaultSustainability2 = _interopRequireDefault(_SolutionDefaultSustainability);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SolutionDefaultSustainability = (_dec = (0, _reactCssModules2.default)(_SolutionDefaultSustainability2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SolutionDefaultSustainability, _Component);

  function SolutionDefaultSustainability(props) {
    (0, _classCallCheck3.default)(this, SolutionDefaultSustainability);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SolutionDefaultSustainability.__proto__ || (0, _getPrototypeOf2.default)(SolutionDefaultSustainability)).call(this, props));

    _this.state = {
      title: 'Make the default investment sustainable',
      description: 'Making the default investment option sustainable is the best way to protect people from the financial risks of unsustainable investments.',
      url: _config2.default.domain + _config2.default.routes.solutionDefaultSustainability
    };
    return _this;
  }

  (0, _createClass3.default)(SolutionDefaultSustainability, [{
    key: 'render',
    value: function render() {
      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'page' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(
          'div',
          { styleName: 'section-top-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section-top-faq-cell' },
              _react2.default.createElement(
                'div',
                { styleName: 'issue-top-label' },
                'SOLUTION: ',
                _react2.default.createElement(
                  'span',
                  null,
                  this.state.title
                )
              ),
              _react2.default.createElement(
                'h1',
                { styleName: 'issue-top-headline' },
                'Sustainability should be the standard'
              ),
              _react2.default.createElement(
                'h2',
                { styleName: 'issue-top-copy' },
                'Making the default investment option sustainable is the best way to protect employees from the financial risks of unsustainable investments.'
              )
            )
          )
        ),
        _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 4 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-headline' },
                  _react2.default.createElement(
                    'span',
                    { style: { whiteSpace: 'nowrap' } },
                    '\u2014\u2014\u2014\u2014'
                  ),
                  _react2.default.createElement('br', null),
                  'Retirement plan default options carry sustainability risks'
                )
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 8 },
                _react2.default.createElement(
                  'div',
                  { styleName: 'issue-second-copy' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'If climate and other sustainability risks are embedded in a fund, retirement plan investors aren\'t just directing trillions of dollars of capital to carbon polluters and weapons makers - they could also be exposed to financial risks from unsustainable investments.'
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    'Given the scale of the world\u2019s sustainability challenges, employee investors need to make sustainability the default. Retirement plan default options should, at minimum, exclude fossil fuel companies, deforestation-risk agribusiness, gun manufacturers, and high-risk prison industrial complex companies.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'section',
            { styleName: 'section' },
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement('div', { styleName: 'img-issue' })
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { xs: 12, md: 6 },
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-label' },
                    'WHY DEFAULTING TO SUSTAINABILITY MATTERS'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-headline' },
                    'Unsustainable investments carry financial risk'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'issue-focus-copy' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Just because the default option is the easiest plan to choose does not mean that it is a safe choice. The default option generally commands the majority of the plan assets: new plan participants often have their contributions automatically allocated to the default, and many never switch.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Evidence indicates sustainability-related risk can negatively impact a company\u2019s stock price as well as its reputation. Asset managers have a fiduciary duty to mitigate the financial risks of climate change and other sustainability issues that could impact performance of the companies held in the default fund.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.eduCenterFinRisks,
                          title: 'Financial risks of unsustainable investments',
                          xstrong: true
                        },
                        'Learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'section-solutions-faq-background' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            _react2.default.createElement(
              'section',
              { styleName: 'section section-solutions-faq' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-label' },
                      'Who we are'
                    ),
                    _react2.default.createElement('img', {
                      src: aysLogo,
                      alt: 'As You Sow',
                      styleName: 'ays-logo'
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-solutions-copy' },
                      _react2.default.createElement(
                        'p',
                        null,
                        'Invest Your Values is a project of ',
                        _react2.default.createElement(
                          'i',
                          null,
                          'As You Sow'
                        ),
                        ', the nation\u2019s non-profit leader in shareholder advocacy. Founded in 1992, we harness shareholder power to create lasting change that benefits people, planet, and profit.'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.about,
                          title: 'About us',
                          xstrong: true
                        },
                        'About us',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 6 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'section-solutions-faq-cell' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-label' },
                      'FAQs'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-headline' },
                      'Answers to common questions about how retirement plans and asset managers are financing unsustainable business practices.'
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-',
                          title: 'Do I have to sacrifice returns in order to invest sustainably?',
                          xstrong: true
                        },
                        'Do I have to sacrifice returns in order to invest sustainably?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-item' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-',
                          title: 'Why should retirement plans add a sustainable investment option?',
                          xstrong: true
                        },
                        'Why should retirement plans add a sustainable investment option?'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'issue-faqs-link' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.faqs,
                          title: 'FAQs',
                          xstrong: true
                        },
                        'View all >>'
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null)
          )
        )
      );
    }
  }]);
  return SolutionDefaultSustainability;
}(_react.Component)) || _class);
exports.default = SolutionDefaultSustainability;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SolutionDefaultSustainability/SolutionDefaultSustainability.js
// module id = 1498
// module chunks = 0